import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React__default, { useContext } from 'react';
import { a as UserProfileContext } from '../UserProfileContext-f3f446d2.js';
import { a as LocalizationContext } from '../LocalizationContext-a82461b5.js';
import Avatar from './Avatar.js';
import MutedAvatarOverlay from './MutedAvatarOverlay.js';
import Checkbox from './Checkbox.js';
import UserProfile from './UserProfile.js';
import ContextMenu, { MenuItems } from './ContextMenu.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import 'prop-types';
import '../stringSet-b60e9529.js';
import '../index-6add7940.js';
import './ImageRenderer.js';
import './Icon.js';
import '../uuid-717930b4.js';
import '../sendbirdSelectors.js';
import '../_rollupPluginBabelHelpers-05128ded.js';
import '../topics-eb548880.js';
import '../utils-e0c7329c.js';
import './Button.js';
import '../useSendbirdStateContext.js';
import '../withSendbird.js';
import 'react-dom';
import './SortByRow.js';
import '../index-579ca9d7.js';
import '../utils/message/getOutgoingMessageState.js';
function UserListItem(_ref) {
  var user = _ref.user,
    className = _ref.className,
    checked = _ref.checked,
    checkBox = _ref.checkBox,
    isOperator = _ref.isOperator,
    disabled = _ref.disabled,
    disableMessaging = _ref.disableMessaging,
    currentUser = _ref.currentUser,
    action = _ref.action,
    _onChange = _ref.onChange,
    _ref$avatarSize = _ref.avatarSize,
    avatarSize = _ref$avatarSize === void 0 ? '40px' : _ref$avatarSize;
  var uniqueKey = user.userId;
  var actionRef = React__default.useRef(null);
  var parentRef = React__default.useRef(null);
  var avatarRef = React__default.useRef(null);
  var _useContext = useContext(UserProfileContext),
    disableUserProfile = _useContext.disableUserProfile,
    renderUserProfile = _useContext.renderUserProfile;
  var _useContext2 = useContext(LocalizationContext),
    stringSet = _useContext2.stringSet;
  return /*#__PURE__*/React__default.createElement("div", {
    className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), ['sendbird-user-list-item']).join(' '),
    ref: parentRef
  }, (user === null || user === void 0 ? void 0 : user.isMuted) && /*#__PURE__*/React__default.createElement(MutedAvatarOverlay, {
    height: 40,
    width: 40
  }), /*#__PURE__*/React__default.createElement(ContextMenu, {
    menuTrigger: function menuTrigger(toggleDropdown) {
      return /*#__PURE__*/React__default.createElement(Avatar, {
        className: "sendbird-user-list-item__avatar",
        ref: avatarRef,
        src: user.profileUrl,
        width: avatarSize,
        height: avatarSize,
        onClick: function onClick() {
          if (!disableUserProfile) {
            toggleDropdown();
          }
        }
      });
    },
    menuItems: function menuItems(closeDropdown) {
      return /*#__PURE__*/React__default.createElement(MenuItems, {
        openLeft: true,
        parentRef: avatarRef
        // for catching location(x, y) of MenuItems
        ,

        parentContainRef: avatarRef
        // for toggling more options(menus & reactions)
        ,

        closeDropdown: closeDropdown,
        style: {
          paddingTop: '0px',
          paddingBottom: '0px'
        }
      }, renderUserProfile ? renderUserProfile({
        user: user,
        currentUserId: currentUser,
        close: closeDropdown
      }) : /*#__PURE__*/React__default.createElement(UserProfile, {
        disableMessaging: disableMessaging,
        user: user,
        currentUserId: currentUser,
        onSuccess: closeDropdown
      }));
    }
  }), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-user-list-item__title",
    type: LabelTypography.SUBTITLE_1,
    color: LabelColors.ONBACKGROUND_1
  }, user.nickname || stringSet.NO_NAME, currentUser === user.userId && ' (You)'),
  // if there is now nickname, display userId
  !user.nickname && /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-user-list-item__subtitle",
    type: LabelTypography.CAPTION_3,
    color: LabelColors.ONBACKGROUND_2
  }, user.userId), checkBox && /*#__PURE__*/React__default.createElement("label", {
    className: "sendbird-user-list-item__checkbox",
    htmlFor: uniqueKey
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    id: uniqueKey,
    checked: checked,
    disabled: disabled,
    onChange: function onChange(event) {
      return _onChange(event);
    }
  })), isOperator && /*#__PURE__*/React__default.createElement(Label, {
    className: ['sendbird-user-list-item__operator', checkBox ? 'checkbox' : ''].join(' '),
    type: LabelTypography.SUBTITLE_2,
    color: LabelColors.ONBACKGROUND_2
  }, "Operator"), action && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-user-list-item__action",
    ref: actionRef
  }, action({
    actionRef: actionRef,
    parentRef: parentRef
  })));
}
export { UserListItem as default };